import 'whatwg-fetch';
import queryString from 'query-string';
import AnalyticsService from './analytics';
import moment from 'moment';
/**
 Store:
 {
  "object": "location",
  "id": 5,
  "name": "Vantaa, Tammisto",
  "url_text": "vantaa_tammisto",
  "address": "Valimotie 29",
  "zip": "01510",
  "city": "Vantaa",
  "phone": "+358800411255",
  "views": [
    {
      "object": "view",
      "id": 1,
      "type": "services",
      "name": "Koirien turkinhoito",
      "url_text": "trimmaus",
      "days": 90,
      "select_worker": {
        "anyone": true,
        "select_yourself": false
      },
      "has_extra_info": true,
      "has_week_browser": true
    }
  ],
  "location": {
    "lat": 60.2859584,
    "lng": 24.9749066
  }
}

 ServiceCategory:
 {
    "id": 250,
    "name": "Monirotuinen",
    "object": "service_category"
},

 Service:
 {
     "description": {
         "object": "description",
         "text": "Koirasi pest\u00e4\u00e4n huolellisesti ja yksil\u00f6llisesti turkin laadulle soveltuvilla aineilla. Pesun j\u00e4lkeen turkki kuivataan tehokuivaimell
a, joka irrottaa irtokarvat ja poistaa kuolleen pohjavillan. Tehokkaan kuivauksen ansiosta karvapeitteest\u00e4 tulee ilmavampi ja helppohoitoisempi. T\u00e4m\u00e4n j\u00e4lkee
n karvapeite siistit\u00e4\u00e4n harjaamalla. Pesupaketti sis\u00e4lt\u00e4\u00e4 my\u00f6s koirasi kynsienleikkuun ja tassujen siistimisen."
     },
     "extra_services": [
         {
             "description": {
                 "object": "description",
                 "text": "Mik\u00e4li koirallasi on rotunsa edustajaksi erityisen runsas turkki, on karvapeitteen k\u00e4sittelyyn hyv\u00e4 varata lis\u00e4aika. N\u00e4in varmistetaan, ett\u00e4 turkki saadaan kauttaaltaan huolellisesti k\u00e4sitelty\u00e4 ja my\u00f6s kuivattua kunnolla."
             },
             "id": 1747,
             "name": "Erityisrunsas turkki",
             "object": "service"
         },
         {
             "description": {
                 "object": "description",
                 "text": "Jos koiralla on takkuja ja/tai huopaantunut turkki, koirallesi kannattaa varata lis\u00e4palveluna takkujen avausk\u00e4sittely. N\u00e4in varmistat, ett\u00e4 trimmatessa takut voidaan poistaa mahdollisimman hell\u00e4varaisesti ja lopputulos on viimeistelty."
             },
             "id": 1997,
             "name": "Takkujen avausk\u00e4sittely",
             "object": "service"
         }
     ],
     "id": 993,
     "name": "Pesupaketti (Affenpinseri)",
     "object": "service"


     fields:
      {
        "id": "extra_control_0",
        "name": "Koiran nimi",
        "object": "form_field",
        "required": true,
        "type": "text"
     },
 }
 */
class DigitalBookerApiClient {

  constructor(systemName, language, errorCallBack) {
    this.systemName = systemName;
    this.language = language;
    this.cache = new Map();
    this.errorCallBack = errorCallBack || function () {
      };
    this.analyticsService = new AnalyticsService();
    this.translations = new Map();
    this.translations.set("fi", new Map([['any_one', 'Kuka tahansa']]));
    this.translations.set("sv", new Map([['any_one', 'Anyone']]));
    this.translations.set("no", new Map([['any_one', 'Anyone']]));
    this._with_cache = this._with_cache.bind(this);
  }

  get_text(valueToTranslate) {
    return this.translations.get(this.language).get(valueToTranslate);
  }


  loadAvailableTimes(location, view, service, resource, extraserviceIds, fromDate) {
    let queryParameters = queryString.stringify({
      'extra_service_ids': extraserviceIds && extraserviceIds.length > 0 ? extraserviceIds.join() : undefined,
      date: fromDate || moment().format('YYYY-MM-DD'),
      worker_id: resource,
    });

    if(fromDate === undefined) {
      queryParameters += "&search_next_date=true";
    }

    return this._fetch('https://www.varaaheti.fi/' + this.systemName + '/' + this.language + '/api/public/locations/' + location + '/views/' + view + '/services/' + service + '/available?' + queryParameters)
      .then(response => response.json());
  }

  loadResources(location, view, service, extraserviceIds) {
    return this._with_cache("resources", [location, view, service, extraserviceIds], () => {
      const queryParameters = queryString.stringify({'extra_service_ids': extraserviceIds && extraserviceIds.length > 0 ? extraserviceIds.join() : undefined});
      return this._fetch('https://www.varaaheti.fi/' + this.systemName + '/' + this.language + '/api/public/locations/' + location + '/views/' + view + '/services/' + service + '/resources?' + queryParameters)
        .then(response => response.json())
        .then(json => json.data)
        .then(resources => {
          resources.push({name: this.get_text("any_one"), id: 0});
          return resources;
        });
    });
  }

  loadFields(location, view) {
    return this._with_cache("fields", [location, view], () => {
      return this._fetch('https://www.varaaheti.fi/' + this.systemName + '/' + this.language + '/api/public/locations/' + location + '/views/' + view + '/extra_info')
        .then(response => response.json())
        .then(json => json.fields);
    });
  }

  fakeBookTime(selections, user, extraInfo) {
    const booking = this.createBookingObject(selections, user, extraInfo);
    this.analyticsService.timeBooked("fake!", booking);
    return Promise.resolve({
      id: "12339",
      delete_token: "b9c52cc0803d82d479ca5a86205b1bfe",
      delete_before: "2017-05-22T10:00:00+03:00",
      resources: [{name: "Noora"}]
    });
  }

  createBookingObject(selections, user, extraInfo) {
    function findExtraServiceInfo(selections) {
      if (selections.extra_services && selections.service.extra_services) {
        const realServices = selections.service.extra_services.filter(extraService => selections.extra_services.indexOf(extraService.id) > -1);
        return {ids: realServices.map(es => es.id), additional_info: realServices.map(es => es.name).join(", ")};
      }
      return {ids: [], additional_info: ""};
    }

    const extraServices = findExtraServiceInfo(selections);
    return {
      type: "service",
      location_id: selections.location.id,
      view_id: selections.view.id,
      service_id: selections.service.id,
      name: selections.service.name,
      extra_service_ids: extraServices.ids,
      additional_info: extraServices.additional_info,
      anyone: true,
      date: moment(selections.time_slot.start).format('YYYY-MM-DD'),
      from: moment(selections.time_slot.start).format('k:mm'),
      to: moment(selections.time_slot.end).format('k:mm'),
      resource_ids: selections.time_slot.resources,
      price: selections.time_slot.price,
      extra_info: extraInfo,
      user: {
        name: user.name,
        email: user.email,
        phone: user.phone,
        accept_terms: user.accept_terms
      }
    };
  }

  bookTime(selections, user, extraInfo) {
    const url = 'https://www.varaaheti.fi/' + this.systemName + '/' + this.language + '/api/public/bookings/service';
    const booking = this.createBookingObject(selections, user, extraInfo);
    return this._fetch(url, {method: "POST", body: JSON.stringify(booking)})
      .then(response => response.json())
      .then(json => {
        this.analyticsService.timeBooked(url, booking);
        return json
      });
  }

  loadServices(location, view, serviceCategory) {
    return this._with_cache("services", [location, view, serviceCategory], () => {
      return this._fetch('https://www.varaaheti.fi/' + this.systemName + '/' + this.language + '/api/public/locations/' + location + '/views/' + view + '/service_categories/' + serviceCategory)
        .then(response => response.json())
        .then(json => json.services);
    });
  }

  loadServiceCategories(location, view) {
    return this._with_cache("categories", [location, view], () => {
      return this._fetch('https://www.varaaheti.fi/' + this.systemName + '/' + this.language + '/api/public/locations/' + location + '/views/' + view + '/service_categories')
        .then(response => response.json())
        .then(json => json.data);
    });
  }

  loadStores() {
    return this._with_cache("stores", undefined, () => this._loadStoresInternal());
  }

  _with_cache(name, args, loadDataFunction) {
    const cacheKey = name + "-" + (args ? args.join() : "");
    if (this.cache.has(cacheKey)) {
      return Promise.resolve(this.cache.get(cacheKey));
    } else {
      return loadDataFunction().then(loadedData => {
        this.cache.set(cacheKey, loadedData);
        return loadedData;
      });
    }
  }

  _fetch(url, options) {
    return fetch(url, options)
      .then(response => {
        if (!response.ok) {
          this.analyticsService.errorWhenFetchingExternalData("response not ok", response.status + " " + response.text, url);
          throw new Error("response was not ok but: " + response.status);
        }
        return response;
      }).catch(error => {
        this.errorCallBack(error);
      });
  }

  _loadStoresInternal() {
    const systemName = this.systemName;
    const language = this.language;
    const that = this;
    return new Promise(function (resolve) {
      function resolveCoordinates(store) {
        return that._fetch('//maps.google.com/maps/api/geocode/json?address=' + store.address + "," + store.city)
          .then(response => response.json())
          .then(json => {
            if (json.status === "OK" && json.results[0].geometry && json.results[0].geometry.location) {
              return json.results[0].geometry.location;
            } else {
              that.analyticsService.dataError("unable to find location for store: ", store, json.status);
            }
          }).then(location => {
            store.location = location;
            return store;
          });
      }

      return that._fetch('https://www.varaaheti.fi/' + systemName + '/' + language + '/api/public/locations')
        .then(response => response.json())
        .then(resp => {
          return resp;
        })
        .then(json => json.data)
        .then(stores => stores.map(store => resolveCoordinates(store)))
        .then(storeLocationPromises => Promise.all(storeLocationPromises))
        .then(storesWithLocation => resolve(storesWithLocation));
    })
  }
}

export {DigitalBookerApiClient as default}



// WEBPACK FOOTER //
// ../utils/digital-booker-api-client.js